@if (featureFile === 'configData') {
  <div class="modal configure-feature" tabindex="-1" role="dialog"
    data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content configure-features-content" id="selectFeatures">
        <!-- <div class="close-btn" (click)="activemodal.dismiss('Cross click')" (keydown.enter)="activemodal.dismiss('Cross click')" (keydown.space)="activemodal.dismiss('Cross click'); $event.preventDefault()"><img class="" src="close.png" alt="Close"></div> -->
        <div class="row">
          <div class="col-5">
            <div id="configure-features-title" class="select-feature">Select features for configuration</div>
            <div id="configure-features-device-name" class="device-name signifyBooklg">{{ deviceInfo.deviceName
              }}&nbsp;&nbsp;&nbsp;{{softwareVerTrim}}<br>{{deviceInfo.device12nc}}</div>
            </div>
            @if (!isFeatureAvailable) {
              <div class="col-2 select">
                @if (!customLoader) {
                  <div>
                    @if (!isFeatureSelected ) {
                      <div id="configure-features-select-all" class="selectall" (click)="selectAll($event)" (keydown.enter)="selectAll($event)" (keydown.space)="selectAll($event); $event.preventDefault()">Select
                      All </div>
                    }
                    @if (isFeatureSelected ) {
                      <div id="configure-features-unselect-all" class="selectall1" (click)="unselectAll($event)" (keydown.enter)="unselectAll($event)" (keydown.space)="unselectAll($event); $event.preventDefault()">
                      UnSelect All</div>
                    }
                  </div>
                }
              </div>
            }
          </div>
          @if (customLoader) {
            <div class="spinner-border text-secondary custom-spinner"></div>
          }
          @if (isFeatureAvailable) {
            <div class="signifyBookxl no-feature">No feature found for the selected device</div>
          }
          <form [formGroup]="startConfigForm" (ngSubmit)="onSubmit()">
            @if (isLuminaire>0 && !isFeatureAvailable) {
              <div class="features-section">
                <div><img class="" src="{{pathVal}}Luminaire.png" alt="Luminaire parameters"></div>
                <div class="featureInfo"><span class="features-section-header">Luminaire parameters</span>
                <img class="info" src="{{pathVal}}info.png" placement="right" [autoClose]="'outside'" [ngbTooltip]="LumConfig"
                  triggers="click:blur" tooltipClass="featureInfo" #LumCon="ngbTooltip" (click)="LumCon.open()" (keydown.enter)="LumCon.open()" (keydown.space)="LumCon.open(); $event.preventDefault()" alt="Information">
                  <ng-template #LumConfig>
                    <div class="row app-area-container">
                      <div class="col-10 title-tooltip">Luminaire parameters</div>
                      <div class="col-2 tooltip-image"><img src="{{pathVal}}close.png" (click)="LumCon.close()" (keydown.enter)="LumCon.close()" (keydown.space)="LumCon.close(); $event.preventDefault()" alt="Close"></div><br />
                      <div class="tooltip-description">
                        <p class="desc">Below you can select the features which you select to modify Luminaire parameters.
                        </p>
                        <p class="desc">On the feature panel you can add and remove features.</p>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="device-features-list">
                @for (feature of featureArray; track feature) {
                  @if (feature === 'AOC') {
                    <div>
                      <input [checked]="aocAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                        [id]="feature" [value]="feature" (change)="onChange('Aoc',$event.target.checked)" />
                        <label [for]="feature"><span></span>{{feature}} <div class="feature-abbr signifyBooksm">(Adjustable
                      output current)</div></label>
                    </div>
                  }
                  @if (feature === 'ALO') {
                    <div>
                      <input [checked]="aloAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                        [id]="feature" [value]="feature" (change)="onChange('Alo',$event.target.checked)" />
                        <label [for]="feature"><span></span>{{feature}} <div class="feature-abbr signifyBooksm">(Adjustable
                      light output)</div></label>
                    </div>
                  }
                  @if (feature === 'SR PSU') {
                    <div>
                      <input [checked]="psuAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                        [id]="feature" [value]="feature" (change)="onChange('Psu',$event.target.checked)" />
                        <label [for]="feature"><span></span>{{feature}} <div class="feature-abbr signifyBooksm">(SR power
                      supply)</div></label>
                    </div>
                  }
                }
              </div>
            }
            @if (isLightControl>0 && !isFeatureAvailable) {
              <div class="features-section">
                <div><img class="" src="{{pathVal}}Light-control-features.png" alt="Light control features"></div>
                <div class=""><span class="features-section-header sub-heading">Light control features</span>
                <img class="info" src="{{pathVal}}info.png" placement="right" [autoClose]="'outside'" [ngbTooltip]="LightConfig"
                  triggers="click:blur" tooltipClass="featureInfo" #LightCon="ngbTooltip" (click)="LightCon.open()" (keydown.enter)="LightCon.open()" (keydown.space)="LightCon.open(); $event.preventDefault()" alt="Information">
                  <ng-template #LightConfig>
                    <div class="row app-area-container">
                      <div class="col-10 title-tooltip">Light control features</div>
                      <div class="col-2 tooltip-image"><img src="{{pathVal}}close.png" (click)="LightCon.close()" (keydown.enter)="LightCon.close()" (keydown.space)="LightCon.close(); $event.preventDefault()" alt="Close"></div><br />
                      <div class="tooltip-description">
                        <p class="desc">In below feature list you can select the features how the luminaire reacts on
                        control input </p>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="device-features-list">
                @for (feature of featureArray; track feature; let index = $index) {
                  <div>
                    @if (feature === '0-10v / 1-10v') {
                      <input [checked]="zTvAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                        [id]="feature" [value]="feature" (change)="onChange('0-10v / 1-10v',$event.target.checked, index)" />
                        <label [for]="feature"><span></span>{{feature}}</label>
                      }
                      @if (feature === 'CLO') {
                        <input [checked]="cloAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                          [id]="feature" [value]="feature" (change)="onChange('Clo',$event.target.checked, index)" />
                          <label [for]="feature"><span></span>{{feature}} <div class="feature-abbr signifyBooksm">(Constant light
                        output)</div></label>
                      }
                      @if (feature === 'CLO Lite') {
                        <ng-container class="startupCSS">
                          <input [checked]="cloLiteAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                            [id]="feature" [value]="feature" (change)="onChange('CloLite',$event.target.checked, index)" />
                            <label [for]="feature"><span></span>CLO <div class="feature-abbr signifyBooksm">(Constant light output)
                          </div></label>
                        </ng-container>
                      }
                      @if (feature === 'Corridor') {
                        <ng-container class="DtlCSS">
                          <input [checked]="corridorAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                            [id]="feature" [value]="feature" (change)="onChange('Corridor',$event.target.checked, index)" />
                            <label class="corridor-margin" [for]="feature"><span></span>Corridor</label>
                          </ng-container>
                        }
                        @if (feature === 'DC Emergency') {
                          <input [checked]="dcemergencyAlwaysChecked=== true" type="checkbox" class="primary-checkbox"
                            name="feature" [id]="feature" [value]="feature"
                            (change)="onChange('DC Emergency',$event.target.checked, index)" />
                            <label class="dcemergencyCss" [for]="feature"><span></span>DC Emergency</label>
                          }
                          @if (feature === 'DTL') {
                            <ng-container class="DtlCSS">
                              <input [checked]="DTLAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                                [id]="feature" [value]="feature" (change)="onChange('DTL',$event.target.checked, index)" />
                                <label class="dtl-margin" [for]="feature"><span></span>DTL <div class="feature-abbr signifyBooksm">
                              (Driver Temeprature Limit)</div></label>
                            </ng-container>
                          }
                          @if (feature === 'Min Dim Level') {
                            <ng-container class="startupCSS">
                              <input [checked]="minDimAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                                [id]="feature" [value]="feature" (change)="onChange('Min Dim Level',$event.target.checked, index)" />
                                <label [for]="feature"><span></span>Minimum Dim Level</label>
                              </ng-container>
                            }
                            @if (feature === 'Startup time') {
                              <ng-container class="startupCSS">
                                <input [checked]="startupAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                                  [id]="feature" [value]="feature" (change)="onChange('Startup time',$event.target.checked, index)" />
                                  <label [for]="feature"><span></span>Startup time</label>
                                </ng-container>
                              }
                              @if (feature === 'Touch and Dim') {
                                <ng-container class="startupCSS">
                                  <input [checked]="touchDimAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                                    [id]="feature" [value]="feature" (change)="onChange('Touch and Dim',$event.target.checked, index)" />
                                    <label [for]="feature"><span></span>Touch and Dim</label>
                                  </ng-container>
                                }
                              </div>
                            }
                          </div>
                        }
                        @if (isLuminaireInfo>0 && !isFeatureAvailable) {
                          <div class="features-section">
                            <div><img class="" src="{{pathVal}}Luminaire-info.png" alt="Luminaire info"></div>
                            <div class=""><span class="features-section-header info-subheading">Luminaire info</span>
                            <img class="info" src="{{pathVal}}info.png" placement="right" [autoClose]="'outside'" [ngbTooltip]="LumInfo"
                              triggers="click:blur" tooltipClass="featureInfo" #LumInT="ngbTooltip" (click)="LumInT.open()" (keydown.enter)="LumInT.open()" (keydown.space)="LumInT.open(); $event.preventDefault()" alt="Information">
                              <ng-template #LumInfo>
                                <div class="row app-area-container">
                                  <div class="col-10 title-tooltip">Luminaire info</div>
                                  <div class="col-2 tooltip-image"><img src="{{pathVal}}close.png" (click)="LumInT.close()" (keydown.enter)="LumInT.close()" (keydown.space)="LumInT.close(); $event.preventDefault()" alt="Close"></div><br />
                                  <div class="tooltip-description">
                                    <p class="desc">With luminaire info you can give control systems information on the luminaire such
                                    as naming, production date, identifier and photometrical information</p>
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                          <div class="device-features-list">
                            @for (feature of featureArray; track feature; let index = $index) {
                              @if (feature === 'Luminaire info') {
                                <div>
                                  <input [checked]="LumInfoAlwaysChecked=== true" type="checkbox" class="primary-checkbox" name="feature"
                                    [id]="feature" [value]="feature" (change)="onChange('LumInfo',$event.target.checked, index)" />
                                    <label [for]="feature"><span></span>{{feature}} </label>
                                  </div>
                                }
                              }
                            </div>
                          }
                          <button id="configure-features-cancel-btn" type="button" class="btn prev-btn"
                          (click)="[activemodal.dismiss('Cross click'), removeId(),setconfiguration()]" (keydown.enter)="[activemodal.dismiss('Cross click'), removeId(),setconfiguration()]" (keydown.space)="[activemodal.dismiss('Cross click'), removeId(),setconfiguration()]; $event.preventDefault()">Cancel</button>
                          <button id="configure-features-continue-btn" type="submit" class="btn next-btn" [disabled]=!isFeatureSelected
                          [ngClass]="{'disabled-btn':!isFeatureSelected}">Continue</button>
                          <!-- <div class="spinner-border submit-spinner" *ngIf="loading" ></div> -->
                        </form>
                      </div>
                      <!-- <div class="modal-content" id="configFeatures"></div> -->
                    </div>
                  </div>
                }


                <!-- Not required Export feature file -->

                @if (featureFile === 'featureData') {
                  <div [ngClass]="{onlyFeaturesData: featureFile === 'featureData'}"
                    class="modal configure-feature" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
                    <div class="modal-dialog-export featureDialog" role="document">
                      <div class="modal-content featureModalContent">
                        <!-- <span class="closeButton" (click)="activemodal.dismiss('Cross click')" (keydown.enter)="activemodal.dismiss('Cross click')" (keydown.space)="activemodal.dismiss('Cross click'); $event.preventDefault()"><img class="close-btn" src="close.png" alt=""></span> -->
                        <!-- <div class="back-arrow" (click)="goBack();" (keydown.enter)="goBack();" (keydown.space)="goBack();; $event.preventDefault()"><img class = "back-arrow-img" src="B-back-arrow-icon.png" alt="">
                        <span class="back-btn">Back</span>
                      </div> -->
                      <div class="featureHeader">
                        <div id="export-dcf-title" class="select-feature">Select features for DCF</div>
                        <div class="device-name">{{featureInfo.deviceName}}&nbsp;&nbsp;{{featuresArraySelected.softwareVersion}}</div>
                        <div class="device-12nc signifyBooklg">{{featuresArraySelected.device12nc}}</div>
                      </div>
                      <form (ngSubmit)="exportFeatureFile()">
                        <div class="modal-body featureBody">
                          @if (ztvFeatureSelected) {
                            <div>
                              <div class="feature-checkbox">
                                <input type="checkbox" class="secondary-checkbox" (change)="onFeatureChange('ZTV',$event.target.checked)"
                                  name="ZTV" [value]="ZTV" id="ZTV" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                  <label for="ZTV" aria-label="ZTV - 0-10v / 1-10v"><span></span></label>
                                </div>
                                <div class="feature-name signifyBookmd">0-10v / 1-10v
                                  @if (!featureInfo.isZtvEdited) {
                                    <span class="feature-label">
                                      <p class="label-name-edited"> Edited</p>
                                    </span>
                                  }
                                  @if (featureInfo.isZtvEdited) {
                                    <span class="feature-label-default">
                                      <p class="label-name">Default</p>
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                            @if (aloFeatureSelected) {
                              <div>
                                <div class="feature-checkbox">
                                  <input type="checkbox" class="secondary-checkbox" (change)="exportFile($event.target.checked)" name="ALO"
                                    [value]="ALO" [checked]='isFeatureChecked' [disabled]="disableCheckbox" id="ALO" />
                                    <label for="ALO" aria-label="ALO - Adjustable light output"><span></span></label>
                                  </div>
                                  <div class="feature-name signifyBookmd">ALO<div class="feature-abbr signifyBooksm">(Adjustable light output)
                                  </div>
                                  @if (featureInfo.isaloEdited) {
                                    <span class="feature-label">
                                      <p class="label-name-edited"> Edited</p>
                                    </span>
                                  }
                                  @if (!featureInfo.isaloEdited) {
                                    <span class="feature-label-default">
                                      <p class="label-name">Default</p>
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                            @if (aocFeatureSelected) {
                              <div>
                                <div class="feature-checkbox">
                                  <input type="checkbox" class="secondary-checkbox" (change)="onFeatureChange('AOC',$event.target.checked)"
                                    name="AOC" [value]="AOC" id="AOC" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                    <label for="AOC" aria-label="AOC - Adjustable output current"><span></span></label>
                                  </div>
                                  <div class="feature-name signifyBookmd">AOC<div class="feature-abbr signifyBooksm">(Adjustable output
                                  current)</div>
                                  @if (featureInfo.isEdited) {
                                    <span class="feature-label">
                                      <p class="label-name-edited"> Edited</p>
                                    </span>
                                  }
                                  @if (!featureInfo.isEdited) {
                                    <span class="feature-label-default">
                                      <p class="label-name">Default</p>
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                            <!-- ZTV feature -->
                            @if (cloFeatureSelected) {
                              <div>
                                <div class="feature-checkbox">
                                  <input type="checkbox" class="secondary-checkbox" (change)="onFeatureChange('AOC',$event.target.checked)"
                                    name="CLO" [value]="CLO" id="CLO" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                    <label for="CLO" aria-label="CLO - Constant light output"><span></span></label>
                                  </div>
                                  <div class="feature-name signifyBookmd">CLO<div class="feature-abbr signifyBooksm">(Constant light output)
                                  </div>
                                  @if (featureInfo.isCLOEdited) {
                                    <span class="feature-label">
                                      <p class="label-name-edited"> Edited</p>
                                    </span>
                                  }
                                  @if (!featureInfo.isCLOEdited) {
                                    <span class="feature-label-default">
                                      <p class="label-name">Default</p>
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                            <!--start DCEmergency feature -->
                            @if (dcemergencyFeatureSelected) {
                              <div>
                                <div class="feature-checkbox">
                                  <input type="checkbox" class="secondary-checkbox"
                                    (change)="onFeatureChange('DC Emergency',$event.target.checked)" name="DCEmergency"
                                    [value]="DCEmergency" id="DCEmergency" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                    <label for="DCEmergency" aria-label="DC Emergency"><span></span></label>
                                  </div>
                                  <div class="feature-name signifyBookmd">DC Emergency
                                    @if (featureInfo.isDcemergencyEdited) {
                                      <span class="feature-label">
                                        <p class="label-name-edited"> Edited</p>
                                      </span>
                                    }
                                    @if (!featureInfo.isDcemergencyEdited) {
                                      <span class="feature-label-default">
                                        <p class="label-name">Default</p>
                                      </span>
                                    }
                                  </div>
                                </div>
                              }
                              <!--End DCEmergency feature -->
                              <!--DTL Start-->
                              @if (dtlFeatureSelected) {
                                <div>
                                  <div class="feature-checkbox">
                                    <input type="checkbox" class="secondary-checkbox" (change)="onFeatureChange('DTL',$event.target.checked)"
                                      name="DTL" [value]="DTL" id="DTL" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                      <label for="DTL" aria-label="DTL - Driver Temperature Limit"><span></span></label>
                                    </div>
                                    <div class="feature-name signifyBookmd">DTL<div class="feature-abbr signifyBooksm">(Driver Temeprature
                                    Limit)</div>
                                    @if (featureInfo.isDtlEdited) {
                                      <span class="feature-label">
                                        <p class="label-name-edited"> Edited</p>
                                      </span>
                                    }
                                    @if (!featureInfo.isDtlEdited) {
                                      <span class="feature-label-default">
                                        <p class="label-name">Default</p>
                                      </span>
                                    }
                                  </div>
                                </div>
                              }
                              <!--DTL End here-->
                              <!--Min DIm Level Start-->
                              @if (minDimLevelFeatureSelected) {
                                <div>
                                  <div class="feature-checkbox">
                                    <input type="checkbox" class="secondary-checkbox"
                                      (change)="onFeatureChange('minDimLevel',$event.target.checked)" name="minDimLevel" [value]="minDimLevel"
                                      id="minDimLevel" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                      <label for="minDimLevel" aria-label="Min Dim Level"><span></span></label>
                                    </div>
                                    <div class="feature-name signifyBookmd">Min Dim Level<div class="feature-abbr signifyBooksm"></div>
                                    @if (featureInfo.isMinDimLevelEdited) {
                                      <span class="feature-label">
                                        <p class="label-name-edited"> Edited</p>
                                      </span>
                                    }
                                    @if (!featureInfo.isMinDimLevelEdited) {
                                      <span class="feature-label-default">
                                        <p class="label-name">Default</p>
                                      </span>
                                    }
                                  </div>
                                </div>
                              }
                              <!--Min Dim Level End here-->
                              @if (psucloFeatureSelected) {
                                <div>
                                  <div class="feature-checkbox">
                                    <input type="checkbox" class="secondary-checkbox" (change)="exportFile($event.target.checked)" name="PSU"
                                      [value]="PSU" [checked]='isFeatureChecked' [disabled]="disableCheckbox" id="PSU" />
                                      <label for="PSU" aria-label="SR PSU - SR power supply"><span></span></label>
                                    </div>
                                    <div class="feature-name signifyBookmd">SR PSU<div class="feature-abbr signifyBooksm">(SR power supply)
                                    </div>
                                    @if (featureInfo.isParamEdited) {
                                      <span class="feature-label">
                                        <p class="label-name-edited"> Edited</p>
                                      </span>
                                    }
                                    @if (!featureInfo.isParamEdited) {
                                      <span class="feature-label-default">
                                        <p class="label-name">Default</p>
                                      </span>
                                    }
                                  </div>
                                </div>
                              }
                              @if (luminoFeatureSelected) {
                                <div>
                                  <div class="feature-checkbox">
                                    <input type="checkbox" class="secondary-checkbox" (change)="exportFile($event.target.checked)"
                                      name="LuminInfo" [value]="LuminInfo" [checked]='isFeatureChecked' [disabled]="disableCheckbox"
                                      id="LuminInfo" />
                                      <label for="LuminInfo" aria-label="Luminaire Info"><span></span></label>
                                    </div>
                                    <div class="feature-name signifyBookmd">Luminaire Info<div class="feature-abbr signifyBooksm"></div>
                                    @if (featureInfo.luminValueEdited) {
                                      <span class="feature-label">
                                        <p class="label-name-edited"> Edited</p>
                                      </span>
                                    }
                                    @if (!featureInfo.luminValueEdited) {
                                      <span class="feature-label-default">
                                        <p class="label-name">Default</p>
                                      </span>
                                    }
                                  </div>
                                </div>
                              }
                              @if (startupFeatureSelected) {
                                <div>
                                  <div class="feature-checkbox">
                                    <input type="checkbox" class="secondary-checkbox"
                                      (change)="onFeatureChange('startuptime',$event.target.checked)" name="startuptime" [value]="startuptime"
                                      id="startuptime" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                      <label for="startuptime" aria-label="Startup time"><span></span></label>
                                    </div>
                                    <div class="feature-name signifyBookmd">Startup time
                                      @if (featureInfo.isStartupEdited) {
                                        <span class="feature-label">
                                          <p class="label-name-edited">Edited</p>
                                        </span>
                                      }
                                      @if (!featureInfo.isStartupEdited) {
                                        <span class="feature-label-default">
                                          <p class="label-name">Default</p>
                                        </span>
                                      }
                                    </div>
                                  </div>
                                }
                                @if (corridorFeatureSelected) {
                                  <div>
                                    <div class="feature-checkbox">
                                      <input type="checkbox" class="secondary-checkbox"
                                        (change)="onFeatureChange('corridor',$event.target.checked)" name="corridor" [value]="corridor"
                                        id="corridor" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                        <label for="corridor" aria-label="Corridor"><span></span></label>
                                      </div>
                                      <div class="feature-name signifyBookmd">Corridor
                                        @if (featureInfo.isCorridorEdited) {
                                          <span class="feature-label">
                                            <p class="label-name-edited">Edited</p>
                                          </span>
                                        }
                                        @if (!featureInfo.isCorridorEdited) {
                                          <span class="feature-label-default">
                                            <p class="label-name">Default</p>
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  }
                                  <!--start TouchDim feature -->
                                  @if (touchDimFeatureSelected) {
                                    <div>
                                      <div class="feature-checkbox">
                                        <input type="checkbox" class="secondary-checkbox"
                                          (change)="onFeatureChange('Touch and Dim',$event.target.checked)" name="touchDim" [value]="touchDim"
                                          id="touchDim" [checked]='isFeatureChecked' [disabled]="disableCheckbox" />
                                          <label for="touchDim" aria-label="Touch and Dim"><span></span></label>
                                        </div>
                                        <div class="feature-name signifyBookmd">Touch and Dim
                                          @if (featureInfo.isTouchDimEdited) {
                                            <span class="feature-label">
                                              <p class="label-name-edited"> Edited</p>
                                            </span>
                                          }
                                          @if (!featureInfo.isTouchDimEdited) {
                                            <span class="feature-label-default">
                                              <p class="label-name">Default</p>
                                            </span>
                                          }
                                        </div>
                                      </div>
                                    }
                                    <!--End TouchDim feature -->
                                  </div>
                                  <div class="modal-footer featureFooter">
                                    @if (loading) {
                                      <div class="spinner-border text-secondary feature-spinner"></div>
                                    }
                                    <button id="export-dcf-cancel-btn" type="button" class="btn export-prev-btn"
                                    (click)="[activemodal.dismiss('Cross click')]" (keydown.enter)="[activemodal.dismiss('Cross click')]" (keydown.space)="[activemodal.dismiss('Cross click')]; $event.preventDefault()">Cancel</button>
                                    <button id="export-dcf-save-btn" type="submit" class="btn export-btn" data-target="#nextModal" [disabled]="!isDisabledButton"
                                    [ngClass]="{'disabled-btn':!isDisabledButton}">Save DCF </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        }

                        <!--Not Required End of export feature file -->

                        <!-- Start of Uploading file   For Load Feature Page-->
                        @if (featureFile === 'uploadDCF') {
                          <div class="modal configure-feature" [id]="'myModal2'" tabindex="-1"
                            role="dialog">
                            <div class="modal-dialog featureDialog" role="document">
                              <div class="modal-content featureModalContent modal-content">
                                <div class="row upload-container">
                                  @if (!showFileName) {
                                    <div id="import-dcf-title" class="col-3 signifyBoldmd select-file">Import Device Configuration File (DCF)</div>
                                  }
                                  @if (showFileName) {
                                    <div id="import-dcf-title-with-file" class="col-3 signifyBoldmd select-file">Import Device Configuration File (DCF)</div>
                                  }
                                  <div class="col-9"></div>
                                </div>
                                @if (!showFileName) {
                                  <div class="row drag">
                                    @if (!showFileName && !isDeviceVersionMismatch && !ismissingfileds) {
                                      <div class="col-7 drag-container">
                                        <div
                                          class="drop-area"
                                          (drop)="onDrop($event)"
                                          (dragover)="onDragOver($event)"
                                          (dragleave)="onDragLeave($event)">
                                          <span class="signifyBoldmd">Drop it here!</span> <br>or<br>
                                          <label id="ImportDCF_fileTrigger" class="add-file signifyBoldmd" for="fileDropRef">Select a DCF</label>
                                          <input
                                            class="input-section"
                                            name="first-Load"
                                            accept=".json"
                                            type="file"
                                            #fileDropRef
                                            id="fileDropRef"
                                            (change)="fileBrowseHandler($event.target.files)"
                                            style="display: none;" />
                                            @if (loadingUpload) {
                                              <div class="spinner-border custom-spinner loading-name"></div>
                                            }
                                          </div>
                                        </div>
                                      }
                                      @if (!showFileName && isDeviceVersionMismatch) {
                                        <div class="col-7 drag-container-mismatch">
                                          <label class="signifyBoldmd mt-50" for="fileDropRef"><strong class="fs-19">Device 12NC or Device software
                                            version not supported.
                                          Please select another file!</strong></label>
                                        </div>
                                      }
                                      @if (ismissingfileds) {
                                        <div class="col-7 drag-container-mismatch">
                                          <label class="signifyBoldmd mt-50" for="fileDropRef"><strong class="fs-19" style="white-space: pre-line;"> {{missingFieldsErrorMsg}}</strong></label>
                                        </div>
                                      }
                                      <div class="col-5"></div>
                                      <div class="col-5"></div>
                                    </div>
                                  }
                                  @if (showFileName) {
                                    <div>
                                      <input class="input-section-selection" appDnd (fileDropped)="onFileDropped($event)" type="file"
                                        accept=".json" #fileDropRef [id]="'fileDropRef'"
                                        (change)="fileBrowseHandler($event.target.files)"  />
                                        <span id="Uploaded_fileName" class="uploaded-file signifyBoldlg">{{fileName}}</span><br>
                                        <span class="signifyBookmd">{{deviceDataFromMetaData?.deviceName}}</span><br>
                                        @if (loading) {
                                          <div class="spinner-border custom-spinner loading-name"></div>
                                        }
                                        @if (newDevice) {
                                          <div class="row search-container">
                                            <div class="col-6 search-device" [ngClass]="{'fileLoad': fileLoad}">
                                              <span class="signifyBookmd">Select device type</span><br>
                                              @for (search of searchTypes; track search; let i = $index) {
                                                <div class="types-search">
                                                  <input class="" type="radio" name="search.id" [value]="search.name" [checked]="search.id === 1"
                                                    (change)="onSearchDevice(search.name)" class="radio-dimension custom-radio"><span
                                                  class="signifyBookmd">{{search.name}}</span>
                                                </div>
                                              }
                                              @if (is12nc) {
                                                <div class="row select-dev"><span class="signifyBoldmd">12NC type</span>
                                                <!-- <div class="col-12"> -->
                                                <div class="col-11 searching" [ngClass]="{'isError': !isError, 'notError': isError}">
                                                  <ng-select [items]="deviceList" bindLabel="device12nc" placeholder="Please specify 12 NC number" [searchable]="true"
                                                    [minTermLength]="3" (change)="select12nc($event)" class="new-devices">
                                                    <ng-template ng-option-tmp let-item="item">
                                                      <span [innerHTML]="item.device12nc"></span>
                                                    </ng-template>
                                                  </ng-select>
                                                </div>
                                              <!-- </div> -->
                                            </div>
                                          }
                                          @if (isName) {
                                            <div class="row select-dev"><span class="signifyBoldmd">Product name</span>
                                            <!-- <div class="col-12"> -->
                                            <div class="col-11 searching" [ngClass]="{'isError': !isError, 'notError': isError}">
                                              <ng-select [items]="deviceList" bindLabel="deviceName" placeholder="Please specify product name" [searchable]="true"
                                                [minTermLength]="3" (change)="selectDeviceName($event)" class="new-devices">
                                                <ng-template ng-option-tmp let-item="item">
                                                  <span [innerHTML]="item.deviceName"></span>
                                                </ng-template>
                                              </ng-select>
                                            </div>
                                          <!-- </div> -->
                                        </div>
                                      }
                                      @if (enableButton) {
                                        <div class="row version-container">
                                          <span class="signifyBoldmd col-12 remove-pad">Firmware nr.</span>
                                          @if (softwareVerTrim?.length == 1) {
                                            <div class="select-firmware-value">
                                              @for (version of softwareVerTrim; track version) {
                                                <span class="info-val"> {{ version }} </span>
                                              }
                                            </div>
                                          }
                                          @if (softwareVerTrim?.length > 1) {
                                            <select class="col-11 new-version"
                                              (change)="onChangeVersion($event.target.value)">
                                              @for (version of softwareVerTrim; track version) {
                                                <option [value]="version" class="info-val">
                                                  {{ version }}
                                                </option>
                                              }
                                            </select>
                                          }
                                        </div>
                                      }
                                    </div><br>
                                  </div>
                                }
                                <!-- end new device -->
                              </div>
                            }
                            <div [ngClass]="{'canelRight':!showFileName}"
                              class="col-7 d-flex justify-content-end flex-row no-padding-end button-group-no-gap">
                              <div class="row btn-cont no-gap">
                                <button
                                  id="import-dcf-retry-btn"
                                  class="btn prev-btn retry-continue-button"
                                  [style.visibility]="(isDeviceVersionMismatch || ismissingfileds) && !showFileName && !showDragArea ? 'visible' : 'hidden'"
                                  (click)="onRetry()" (keydown.enter)="onRetry()" (keydown.space)="onRetry(); $event.preventDefault()"
                                >Retry</button>
                                @if (!showFileName) {
                                  <button
                                    id="import-dcf-cancel-btn"
                                    type="button"
                                    class="btn prev-btn"
                                    [ngClass]="{'fileLoad': fileLoad}"
                                    (click)="[activemodal.dismiss('Cross click'), remove()]" (keydown.enter)="[activemodal.dismiss('Cross click'), remove()]" (keydown.space)="[activemodal.dismiss('Cross click'), remove()]; $event.preventDefault()"
                                  >Cancel</button>
                                }
                              </div>
                              @if (showFileName) {
                                <button id="import-dcf-cancel-with-file-btn" type="button" class="btn prev-btn" [ngClass]="{'fileLoad': fileLoad}"
                                (click)="[activemodal.dismiss('Cross click'), remove()]" (keydown.enter)="[activemodal.dismiss('Cross click'), remove()]" (keydown.space)="[activemodal.dismiss('Cross click'), remove()]; $event.preventDefault()">Cancel</button>
                              }
                            </div>
                            @if (!showFileName && isDeviceVersionMismatch) {
                              <div class="row btn-cont-mismatch" [ngClass]="{'canelRight':showFileName}"
                                >
                                <button id="import-dcf-mismatch-cancel-btn" type="button" class="btn prev-btn weight" [ngClass]="{'fileLoad': fileLoad}"
                                (click)="[activemodal.dismiss('Cross click'), remove()]" (keydown.enter)="[activemodal.dismiss('Cross click'), remove()]" (keydown.space)="[activemodal.dismiss('Cross click'), remove()]; $event.preventDefault()">Cancel</button>
                                <button id="import-dcf-mismatch-select-btn" type="button" class="btn select-btn weight" [ngClass]="{'fileLoad': fileLoad}"
                                (click)="backToLoadFF()" (keydown.enter)="backToLoadFF()" (keydown.space)="backToLoadFF(); $event.preventDefault()">Select</button>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    <!-- End of Uploading file-->


                    @if (featureFile === 'readDevice') {
                      <div class="modal configure-feature" [id]="'myModal2'" tabindex="-1" role="dialog">
                        <div class="modal-dialog featureDialog" role="document">
                          <div class="modal-content featureModalContent modal-content">
                            <div class="row upload-container">
                              <div id="configure-read-device-title" class="col-3 signifyBoldmd select-file">Read Device</div>
                              <div class="col-9"></div>
                            </div>
                            <div class="row box-container-margin">
                              <div class="col-7 box-container" style="width: 81.5em;">
                                <br>
                                  <div id="configure-read-device-status-title" class="signifyBoldlg center-text">Status</div><br><br>
                                  <div class="signifyBooklg center-text">{{readingStatus?.serverStatus}}...</div><br>
                                  @if (readingStatus?.serverStatus === 'Started') {
                                    <div class="signifyBooklg center-text">Succesfully
                                    conncected with multione direct config</div>
                                  }
                                  @if (readingStatus?.serverStatus !== 'Started') {
                                    <div class="signifyBooklg center-text">Not able to conncect
                                    with multione direct config</div>
                                  }
                                </div>
                                <div class="col-5"></div>
                              </div>
                              <div class="row btn-cont">
                                <div class="col-4"></div>
                                <button id="configure-read-device-cancel-btn" type="button" class="btn prev-btn" (click)="[activemodal.dismiss('Cross click')]" (keydown.enter)="[activemodal.dismiss('Cross click')]" (keydown.space)="[activemodal.dismiss('Cross click')]; $event.preventDefault()">Cancel read
                                device</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      <!---End of Read device-->
